import { render, staticRenderFns } from "./resdps-help-tip.vue?vue&type=template&id=59bc5867&scoped=true&"
import script from "./resdps-help-tip.vue?vue&type=script&lang=js&"
export * from "./resdps-help-tip.vue?vue&type=script&lang=js&"
import style0 from "./resdps-help-tip.vue?vue&type=style&index=0&id=59bc5867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc5867",
  null
  
)

export default component.exports